export default {
  // 登录
  login(axios, data) {
    return axios.post('/auth-service/api/auth/login', data)
  },
  
  // 注册
  register(axios, data) {
    return axios.post('/auth-service/api/register', data)
  },
  
  // 发送注册验证码
  sendRegisterSms(axios, phone) {
    return axios.post('/auth-service/api/register/send-sms', { phone })
  },
  
  // 验证令牌
  verifyToken(axios, token) {
    return axios.get('/auth-service/api/auth/verify-token', { params: { token } })
  }
}
